import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import LongLayover from '@/assets/icons/LongLayover'
import ShortLayover from '@/assets/icons/ShortLayover'
import TechnicalLayover from '@/assets/icons/TechnicalLayover'

export const ShortLayoverBlock = () => {
    return (
        <Container className="flex flex-middle">
            <Container>
                <ShortLayover />
            </Container>
            <Typography className="ml-2" color="subheading" variant="HM4">
                Short layover
            </Typography>
        </Container>
    )
}

export const LongLayoverBlock = () => {
    return (
        <Container className="flex flex-middle">
            <Container>
                <LongLayover />
            </Container>
            <Typography className="ml-2" color="subheading" variant="HM4">
                Long layover
            </Typography>
        </Container>
    )
}

export const TechnicalLayoverBlock = () => {
    return (
        <Container className="flex flex-middle">
            <Container>
                <TechnicalLayover />
            </Container>
            <Typography className="ml-2" color="subheading" variant="HM4">
                Technical Layover
            </Typography>
        </Container>
    )
}
